import { useState } from 'react'
import { Button, Flex } from '@jisr-hr/ds'
import {
  cloneParentOrgDepartments,
  departmentsPost,
  hierarchicalDepartmentsLoad,
  listDepartmentsLoad,
} from 'redux/newDepartments/actionCreators'
import { Form } from 'redux/newDepartments/types'
import { useDispatch, useSelector } from 'utils/hooks'
import i18n from 'translations/i18n'
import { organizationInfo } from 'redux/organizationOnborading/organization/actionCreators'
import { mixPanelAnalytics } from 'utils/mixpanel'
import DSIcon from 'components/DSIcon'
import DepartmentForm, { FormTypes } from './DepartmentForm'
import { useDepartmentsContext } from './context'

const AddParentDepartemnt = (): JSX.Element => {
  const [isOpen, setIsOpen] = useState(false)
  const dispatch = useDispatch()
  const { isInOnboarding, setSearch } = useDepartmentsContext()

  const { cloning, hierarchical_departments } = useSelector((s) => s.newDepartments)
  const org = useSelector((s) => s.auth.employee?.organization)
  const isNewOnboarding = org?.status === 'onboarding_phase' && org.new_onboarding_enabled
  const isSubOrg = useSelector(
    ({ organization }) => organization?.organization?.is_organization_subsidiary,
  )

  const onSubmit = (values: Form, form: FormTypes): void => {
    // if (Number(values.parent_id) === 0) delete values.parent_id
    dispatch(departmentsPost(values)).then(() => {
      if (isInOnboarding) {
        dispatch(organizationInfo())
      }
      form.reset()
      setIsOpen(false)
      setSearch({ value: values.child_id })
      dispatch(hierarchicalDepartmentsLoad())
      dispatch(listDepartmentsLoad())
    })
  }

  const handleCloneParentLocations = (): void => {
    dispatch(cloneParentOrgDepartments()).then(() => {
      dispatch(hierarchicalDepartmentsLoad())
      dispatch(listDepartmentsLoad())
    })
  }

  return (
    <div>
      {(isInOnboarding || isNewOnboarding) && (
        <Flex
          itemsCenter
          style={{ gap: 8 }}
        >
          {isSubOrg && !hierarchical_departments?.length && (
            <Button
              label={i18n.t('label.import_from_main_organization')}
              variant="secondary"
              iconLeading={<DSIcon name="download-01" />}
              onClick={handleCloneParentLocations}
              disabled={cloning}
              size="md"
            />
          )}
          <Button
            label={i18n.t('add_new_department')}
            iconLeading={<DSIcon name="plus" />}
            onClick={(): void => {
              setIsOpen(true)
              mixPanelAnalytics({ event_name: 'NewDepartment_Initiated' })
            }}
            size="md"
          />
        </Flex>
      )}
      <DepartmentForm
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        onSubmit={onSubmit}
      />
    </div>
  )
}

export default AddParentDepartemnt
